<template>
	<div id="recruit">
		<div :class="scrollFlag?'topLan1':'topLan'">
			<img  @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link :class="scrollFlag?'box1':'box'" :to="{path: 'index'}">首页</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'platform'}">电商平台</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'about'}">关于我们</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'recruit'}">人才招聘
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a href="index" :class="scrollFlag?'box1':'box'">首页</a>
				<a href="platform" :class="scrollFlag?'box1':'box'">电商平台</a>
				<a href="canvass" :class="scrollFlag?'box1':'box'">招商入驻</a>
				<a href="about" :class="scrollFlag?'box1':'box'">关于我们</a>
				<a href="newsCenter" :class="scrollFlag?'box1':'box'">新闻中心</a>
				<a href="recruit" :class="scrollFlag?'box1':'box2'">人才招聘
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</a>
				<a href="downLoad" :class="scrollFlag?'box1':'box'">下载APP</a> -->
			</div>
		</div>

		<div id="id1" style="width: 100%;">
			<img style="width: 100%;" mode="widthFix" src="../../static/pic/img_web06_banner1.jpg" />
		</div>

		<div class="recruitArea" v-for="(item,index) in jList" :key="index">
			<div class="recruitSmallArea">
				<div class="recruitTitle">{{item.title}}</div>
				<div class="basicInfoLan">
					<div class="recruitBox">
						<img style="width: 18px;height: 20px;" src="../../static/recruitPic/icon_web6_zp1@2x.png" />
						<div class="boxtxt">工作地区：{{item.workPlace}}</div>
					</div>
					<div class="recruitBox">
						<img style="width: 17px;height: 20px;" src="../../static/recruitPic/icon_web6_zp2@2x.png" />
						<div class="boxtxt">工资待遇：{{item.salary}}</div>
					</div>
					<div class="recruitBox">
						<img style="width: 18px;height: 20px;" src="../../static/recruitPic/icon_web6_zp3@2x.png" />
						<div class="boxtxt">招聘人数：{{item.recruitNum}}</div>
					</div>
					<div class="recruitBox">
						<img style="width: 20px;height: 20px;" src="../../static/recruitPic/icon_web6_zp4@2x.png" />
						<div class="boxtxt">工作经验：{{item.workExperience}}</div>
					</div>
				</div>
				<div class="RecruitDetail">
					<p class="ql-editor" v-html="item.content"></p>
				</div>
				<div class="recruitBtn" @click="openDialog(item.title)">立即申请该职位</div>
				<div class="recruitLine"></div>
			</div>
		</div>

		<!-- <div class="recruitArea">
			<div class="recruitSmallArea">
				<div class="recruitTitle">产品工程师</div>
				<div class="basicInfoLan">
					<div class="recruitBox">
						<img style="width: 18px;height: 20px;"  src="../../static/recruitPic/icon_web6_zp1@2x.png"/>
						<div class="boxtxt">工作地区：重庆市</div>
					</div>
					<div class="recruitBox">
						<img style="width: 17px;height: 20px;"  src="../../static/recruitPic/icon_web6_zp2@2x.png"/>
						<div class="boxtxt">工资待遇：面议</div>
					</div>
					<div class="recruitBox">
						<img style="width: 18px;height: 20px;"  src="../../static/recruitPic/icon_web6_zp3@2x.png"/>
						<div class="boxtxt">招聘人数：1人</div>
					</div>
					<div class="recruitBox">
						<img style="width: 20px;height: 20px;"  src="../../static/recruitPic/icon_web6_zp4@2x.png"/>
						<div class="boxtxt">工作经验：2年</div>
					</div>
				</div>
				<div class="RecruitDetail">
					
				</div>
				<div class="recruitBtn">立即申请该职位</div>
				<div class="recruitLine"></div>
			</div>
		</div> -->

		<bottom-area></bottom-area>

		<el-dialog title="提交信息" custom-class="dialogClass" :visible.sync="open" width="900px" :before-close="cancel">
			<div class="dialogLine"></div>
			<el-form :model="form" :rules="rules" ref="form" style="margin-top: 48px;">
				<el-row :gutter="14">
					<el-col :span="12">
						<el-form-item prop="name">
							<div class="dialogBox">
								<div class="inputTitle">姓名</div>
								<el-input v-model="form.name"></el-input>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="tel">
							<div class="dialogBox">
								<div class="inputTitle">联系方式</div>
								<el-input v-model="form.tel"></el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="dialogBtnLan">
				<div class="dialogBtn" @click="signUp()">确认提交</div>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import {
		jobList,
		enroll
	} from "../../api/recruit.js"
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			var checkName = (rule, value, callback) => {
				if (value == null || value == '') {
					callback(new Error('联系人不能为空'));
				} else {
					callback();
				}
			}
			var checkTel = (rule, value, callback) => {
				if (value == null || value == '') {
					callback(new Error('联系电话不能为空'));
				} else {
					if (value.length !== 11) {
						callback(new Error('请输入11位手机号'));
					} else {
						callback();
					}
				}
			}
			return {
				windowHeight: String(document.documentElement.clientHeight),
				scrollFlag: false,
				open: false,
				form: {
					name: null,
					tel: null,
					jobTitle: null,
				},
				jList: [],
				rules: {
					name: [{
						validator: checkName,
						trigger: 'blur'
					}],
					tel: [{
						validator: checkTel,
						trigger: 'blur'
					}],
				}

			}
		},
		created() {
			this.getJobList()
			document.documentElement.scrollTop = 0
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			openDialog(title) {
				this.open = true
				this.form.jobTitle = title
			},
			handleScroll() {
				let _this = this;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// console.log(scrollTop)
				if (scrollTop) {
					_this.scrollFlag = true
				} else {
					_this.scrollFlag = false
				}
			},
			getJobList() {
				jobList().then(res => {
					this.jList = res.data
				}).catch(err => {
					console.log(err)
				})
			},
			cancel() {
				this.form.jobTitle = null
				this.open = false
			},
			signUp() {
				this.$refs["form"].validate(valid => {
					console.log(valid)
					if (valid) {
						enroll(this.form).then(res => {
							console.log(res)
							if (res.code == 200) {
								this.$message({
									message: '提交成功，我们稍后会与您联系',
									type: 'success'
								});
								this.cancel()
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.$message.error('请完整填写信息');
					}
				});
			},
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped="scoped">
	html,
	body,
	#recruit {
		width: 100%;
		height: 100%;
		text-align: left;
	}

	.box2 {
		color: #467CFD !important;
		position: relative;
		height: 122px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		line-height: 122px;
		text-align: center;
	}

	.recruitArea {
		margin-top: 100px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.recruitSmallArea {
		width: 1220px;
		display: flex;
		flex-direction: column;
	}

	.recruitTitle {
		width: 100%;
		font-size: 26px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #222222;
	}

	.basicInfoLan {
		width: 100%;
		margin-top: 23px;
		display: flex;
	}

	.recruitBox {
		display: flex;
		margin-right: 50px;
		height: 20px;
	}

	.boxtxt {
		margin-left: 8px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #3E3E3E;
	}

	.recruitBtn {
		width: 220px;
		height: 58px;
		border: 2px solid #B3CFFD;
		border-radius: 4px;
		line-height: 58px;
		text-align: center;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
		margin-top: 48px;
		cursor: pointer;
	}

	.recruitLine {
		margin-top: 88px;
		width: 100%;
		height: 1px;
		/* border: 1px solid #D8D8D8; */
		background-color: #D8D8D8;
	}

	.dialogClass {
		border-radius: 20px;
	}

	.dialogLine {
		width: 100%;
		height: 3px;
		background: #467CFD;
	}

	.dialogBox {
		width: 100%;
		height: 53px;
		background: #FFFFFF;
		border: 2px solid #CCDBFF;
		border-radius: 4px;
		position: relative;
		display: flex;
	}

	.inputTitle {
		width: 80px;
		height: 53px;
		line-height: 53px;
		font-size: 14px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
		text-align: center;
	}

	.el-input__inner {
		width: 300px;
		height: 53px;
		line-height: 53px;
		border: 0;
	}

	.dialogBtnLan {
		width: 100%;
		height: 59px;
		margin-top: 42px;
		margin-bottom: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.dialogBtn {
		width: 241px;
		height: 59px;
		background: linear-gradient(90deg, #5E9EF6, #317AE5);
		border-radius: 8px;
		text-align: center;
		line-height: 59px;
		font-size: 14px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
	}

	.RecruitDetail {
		width: 100%;
		margin-top: 136px;
	}
</style>
